import { StyledAppDefaultMarginsClasses } from '@app/components/shared/app-main-container.styles';
import type * as React from 'react';
import { twMerge } from 'tailwind-merge';

export type ContentPageProps = JSX.IntrinsicElements['div'] & {
    children?: React.ReactNode;
};

export default function ContentPage({ className, children, ...rest }: ContentPageProps) {
    return (
        <div
            {...rest}
            className={twMerge(
                StyledAppDefaultMarginsClasses,
                'mx-auto px-[20px] sm:px-[30px] md:max-w-[1024px] lg:px-0',
                className
            )}
        >
            {children}
        </div>
    );
}
